export default __webpack_public_path__ + "static/media/sc39.6fc4800a.mp4";